var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialIcon9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10208",
    "data-name": "Group 10208",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2233",
    "data-name": "Rectangle 2233",
    width: 13,
    height: 13,
    fill: "#152c40"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10207",
    "data-name": "Group 10207",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27572",
    "data-name": "Path 27572",
    d: "M17.983,19.3a1.314,1.314,0,1,0-1.315-1.315A1.315,1.315,0,0,0,17.983,19.3m0-2.162a.848.848,0,1,1-.848.847.848.848,0,0,1,.848-.847",
    transform: "translate(-11.483 -11.483)",
    fill: "#152c40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27573",
    "data-name": "Path 27573",
    d: "M11.242,15.6a4.358,4.358,0,1,0-4.359-4.359A4.358,4.358,0,0,0,11.242,15.6M8.447,13.943l.533-.812a2.928,2.928,0,0,0,1.163.846l-.606.757a3.892,3.892,0,0,1-1.09-.792Zm1.364-2.237a.236.236,0,0,0-.141-.146l-.911-.344A2.489,2.489,0,0,1,9.219,9.8l.939.256a.348.348,0,0,0,.062.008.235.235,0,0,0,.233-.222l.046-.973a2.513,2.513,0,0,1,1.485,0l.047.973a.233.233,0,0,0,.233.222.324.324,0,0,0,.061-.008l.939-.256a2.471,2.471,0,0,1,.459,1.412l-.911.344a.233.233,0,0,0-.14.147.23.23,0,0,0,.027.2l.533.814a2.466,2.466,0,0,1-1.2.872l-.609-.761a.243.243,0,0,0-.365,0l-.609.761a2.474,2.474,0,0,1-1.2-.872l.534-.814a.233.233,0,0,0,.027-.2M7.392,10.7a3.852,3.852,0,0,1,.414-1.283l.939.256A2.964,2.964,0,0,0,8.3,11.04Zm6.79.342a2.953,2.953,0,0,0-.445-1.368l.941-.256a3.859,3.859,0,0,1,.413,1.283Zm-4.2,3.879,1.256-1.569L12.5,14.92a3.824,3.824,0,0,1-2.513,0m2.961-.186-.606-.757A2.934,2.934,0,0,0,13.5,13.13l.534.812a3.9,3.9,0,0,1-1.091.792m1.4-1.163-1.1-1.678,1.881-.711c0,.02,0,.039,0,.058a3.868,3.868,0,0,1-.781,2.331M14.421,9l-1.937.531-.095-2.011A3.911,3.911,0,0,1,14.421,9M11.915,7.412l.047.971a3,3,0,0,0-1.439,0l.046-.971a3.7,3.7,0,0,1,1.348,0ZM10.1,7.522,10,9.533,8.064,9A3.911,3.911,0,0,1,10.1,7.522m-2.742,3.66,1.882.711-1.1,1.678a3.861,3.861,0,0,1-.783-2.331c0-.02,0-.039,0-.058",
    transform: "translate(-4.742 -4.742)",
    fill: "#152c40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27574",
    "data-name": "Path 27574",
    d: "M6.5,13A6.5,6.5,0,1,0,0,6.5,6.5,6.5,0,0,0,6.5,13M2.449,2.033l.4.472.357-.3-.395-.471A6.073,6.073,0,0,1,4.22.915l.21.581.439-.161L4.657.755A5.992,5.992,0,0,1,6.267.473V1.09h.467V.473a5.992,5.992,0,0,1,1.61.282l-.212.581.439.161.21-.581a6.022,6.022,0,0,1,1.413.819l-.4.471.357.3.4-.472A6.1,6.1,0,0,1,11.6,3.285l-.536.307L11.3,4l.534-.309a6.05,6.05,0,0,1,.56,1.535l-.609.108.08.458.609-.107a5.933,5.933,0,0,1,0,1.633l-.608-.107-.082.459.609.108a5.954,5.954,0,0,1-.56,1.535L11.3,9l-.233.4.533.309a6.042,6.042,0,0,1-1.05,1.25l-.4-.471-.357.3.395.47a5.972,5.972,0,0,1-1.413.819l-.212-.58-.439.159.212.581a5.967,5.967,0,0,1-1.608.283v-.617H6.267v.617a5.994,5.994,0,0,1-1.61-.283l.212-.581L4.429,11.5l-.209.58a5.947,5.947,0,0,1-1.413-.819l.395-.47-.358-.3-.4.471A6.042,6.042,0,0,1,1.4,9.714l.533-.309L1.7,9l-.533.309A6.048,6.048,0,0,1,.6,7.776l.609-.108-.082-.459-.608.107a5.933,5.933,0,0,1,0-1.633l.608.107.082-.458L.6,5.223a5.957,5.957,0,0,1,.56-1.535L1.7,4l.233-.4L1.4,3.285a6.091,6.091,0,0,1,1.05-1.252",
    transform: "translate(0 0)",
    fill: "#152c40"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon9);
export default __webpack_public_path__ + "static/media/social-icon9.93b19d77eb3e29b0a205d2ca444fb62b.svg";
export { ForwardRef as ReactComponent };